import { gatewayServiceBaseUrl } from "lib/consts/arcGateway";
import { isHttpSecure } from "lib/utils/utils";

/** Must match osm_tile_server default / systemd Environment=OSM_TILE_PORT. */
export const DEFAULT_OSM_TILE_PORT = "12410";

/** Browser → OSMF CDN directly (opt-in). Host-side proxy is the default. */
export const DEFAULT_OSM_CDN_URL_TEMPLATE =
    "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

function isOsmCdnDirectEnabled(): boolean {
    const v = process.env.REACT_APP_OSM_USE_CDN?.trim().toLowerCase();
    return v === "1" || v === "true" || v === "yes";
}

/**
 * Leaflet TileLayer URL template for GPS / OpenStreetMap mini-view.
 *
 * Default: ARC-local osm_tile_server (host fill-on-miss when online; disk cache).
 *   Direct: gateway `/api/osm-tiles/{z}/{x}/{y}.png`
 *   Fleet:  `https://{proxyHost}/arc/{serial}/api/osm-tiles/{z}/{x}/{y}.png`
 * Opt-in browser→CDN: set REACT_APP_OSM_USE_CDN=true
 * Override any host: REACT_APP_OSM_TILE_URL_TEMPLATE
 */
export function getOsmTileUrlTemplate(
    arcHost?: string | null,
    isSecure: boolean = isHttpSecure(),
    arcId?: string | null,
): string {
    const explicit = process.env.REACT_APP_OSM_TILE_URL_TEMPLATE?.trim();
    if (explicit) {
        return explicit;
    }

    if (isOsmCdnDirectEnabled()) {
        return DEFAULT_OSM_CDN_URL_TEMPLATE;
    }

    const gatewayBase = gatewayServiceBaseUrl("osmTiles", arcId, arcHost);
    if (gatewayBase) {
        return `${gatewayBase.replace(/\/$/, "")}/{z}/{x}/{y}.png`;
    }

    const port =
        process.env.REACT_APP_OSM_TILE_PORT?.trim() || DEFAULT_OSM_TILE_PORT;
    const host =
        process.env.REACT_APP_OSM_TILE_HOST?.trim() ||
        arcHost?.trim() ||
        process.env.REACT_APP_SINGLE_ARC_HOSTNAME?.trim() ||
        process.env.REACT_APP_HOST_OVERRIDE?.trim() ||
        (typeof window !== "undefined" ? window.location.hostname : "");

    if (!host) {
        if (typeof window !== "undefined") {
            return `${window.location.protocol}//${window.location.host}/api/osm-tiles/{z}/{x}/{y}.png`;
        }
        return "/api/osm-tiles/{z}/{x}/{y}.png";
    }

    if (arcId) return "";

    const protocol = isSecure ? "https" : "http";
    // Do not use URL() — it percent-encodes Leaflet {z}/{x}/{y}.
    const template = `${protocol}://${host}:${port}/{z}/{x}/{y}.png`;
    return template;
}
